/*
 Taken from:
 https://github.com/christo-pr/dangerously-set-html-content

 We need this because editorial developers are executing JS with
 <script> blocks inside their embedded content. React does not
 execute JS when you set it in dangerouslySetInnerHTML
 */
import { useEffect, useRef, createElement } from 'react';

import type React from 'react';

interface DangerouslySetHtmlContentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  html: string;
  allowRerender?: boolean;
}

export const DangerouslySetHtmlContent: React.FC<
  DangerouslySetHtmlContentProps
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
> = ({ html, dangerouslySetInnerHTML, allowRerender, ...rest }) => {
  // We remove 'dangerouslySetInnerHTML' from props passed to the div
  const divRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef<boolean>(true);

  useEffect(() => {
    if (!html || !divRef.current) throw new Error("html prop can't be null");
    if (!isFirstRender.current) return;
    isFirstRender.current = Boolean(allowRerender);

    const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
    divRef.current.innerHTML = ''; // Clear the container
    divRef.current.appendChild(slotHtml); // Append the new content
  }, [html, allowRerender]);

  return createElement('div', { ...rest, ref: divRef });
};
